import React from "react";

export default function NewNotFound({ img, width, title, subTitle, topSelling }) {
  return (
    <div
      style={{
        textAlign: "center",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
      }}
    >
      <div>
        <img src={img} alt="" width={width || "150"} />

        <p
          style={{
            fontSize: "22px",
            fontWeight: "700",
            color: "black",
            lineHeight: 1.5,
            marginTop: !topSelling ? "-20px":10
          }}
        >
          {title}
        </p>
        <h6 style={{fontWeight:400, lineHeight:1.5, marginTop:10}}>{subTitle}</h6>
      </div>
    </div>
  );
}
